// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {CameraLayoutOptionsContainer} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-tbt",
	templateUrl: "./recorder-layout-tbt.component.html",
	styleUrls: ["./recorder-layout-tbt.component.scss"],
	standalone: false,
})
export class RecorderLayoutTbtComponent extends BaseRecorderLayout implements OnInit {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	constructor() {
		super();
	}

	ngOnInit() {}
}
